import ApiService from '@/services/api.service.js';

export const ReportsService = {

  getEvaluations: function (data) {
    return ApiService.post('/reports/get-evaluations', data);
  },

  getEvaluation: function (applicationId) {
    return ApiService.get('/reports/get-evaluation/' + applicationId);
  },

  getFilters: function (data) {
    return ApiService.post('/reports/filters', data);
  },

  exportEvaluation: function (data) {
    return ApiService.post('/reports/export', data);
  },

  exportFinalRanking: function (data) {
    return ApiService.post('/reports/export-final-ranking', data);
  },

  generateReports: function () {
    return ApiService.get('/reports/generate-reports');
  }
}

export default ReportsService